// extracted by mini-css-extract-plugin
export default {"wrapper":"R9to44","closeIcon":"ycNyYE","header":"ojD4KK","content":"U32OGH","scrollable":"ZaQ8Nx","footer":"LiiyHB"};